import nansi from './index.vue'
import nansiHome from './Home.vue'

const dehumidifier = () => import('./dehumidifier.vue')
const dehumidifierTower = () => import('./dehumidifierTower.vue')
const stationFlow = ()=> import('./stationFlow.vue')
const stationSetting = ()=> import('./stationSetting.vue')
const emptyComponent = () => import('./emptyRouterComponent.vue')

// const airValve = ()=> import('./airValve.vue')
// const ventilation = ()=>import('./ventilationNew.vue')
// const remoteHistory = ()=>import('./../../components/RemoteHistory.vue')
const dataHistory = () => import('./../../components/DataHistory.vue')
// const bridgeImg = () => import('./bridgeImg.vue')
 const login = () => import('./login.vue')

export default [
  {
    path: '/nansiIndex',
    name: 'nansiIndex',
    component: nansiHome
  },
  {
    path: '/nansi/login',
    name: 'nansiLogin',
    component: login
  },
  {
    path: '/nansi',
    name: 'nansi',
    redirect: '/nansi/steelBox',
    component: nansi,
    children: [
      {
        path: 'steelBox',
        name: 'steelBox',
        redirect: '/nansi/steelBox/NA12',
        component: emptyComponent,
        children: [
          {
            path: 'NA12',
            name: 'NA12',
            component: dehumidifier
          },
          {
            path: 'NJ09',
            name: 'NJ09',
            component: dehumidifier
          },
          {
            path: 'NA12',
            name: 'NA12',
            component: dehumidifier
          },
          {
            path: 'NJ27',
            name: 'NJ27',
            component: dehumidifier
          },
          {
            path: 'NJ44',
            name: 'NJ44',
            component: dehumidifier
          },
          {
            path: 'SJ27',
            name: 'SJ27',
            component: dehumidifier
          },
          {
            path: 'SJ09',
            name: 'SJ09',
            component: dehumidifier
          },
          {
            path: 'SA12',
            name: 'SA12',
            component: dehumidifier
          },
        ]
      },
      {
        path: 'tower',
        name: 'tower',
        redirect: '/nansi/tower/Qixia',
        component: emptyComponent,
        children: [
          {
            path: 'Qixia',
            name: 'Qixia',
            component: dehumidifierTower
          },
          {
            path: 'Liuhe',
            name: 'Liuhe',
            component: dehumidifierTower
          },
        ]
      },
      {
        path: 'stationFlow',
        name: 'stationFlow',
        redirect: '/nansi/stationFlow/NorthStation',
        component: emptyComponent,
        children: [
          {
            path: 'NorthStation',
            name: 'NorthStation',
            component: stationFlow
          },
          {
            path: 'SouthStation',
            name: 'SouthStation',
            component: stationFlow
          },
          {
            path: 'MiddleStation',
            name: 'MiddleStation',
            component: stationFlow
          },
        ]
      },
      {
        path: 'stationSetting',
        name: 'stationSetting',
        redirect: '/nansi/stationSetting/NorthStation',
        component: emptyComponent,
        children: [
          {
            path: 'NorthStation',
            name: 'NorthStation',
            component: stationSetting
          },
          {
            path: 'SouthStation',
            name: 'SouthStation',
            component: stationSetting
          },
          {
            path: 'MiddleStation',
            name: 'MiddleStation',
            component: stationSetting
          },
        ]
      },
      {
        path: 'dataHistory',
        name: 'nansi_dataHistory',
        component: dataHistory
      },

    ]
  }
]
